/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'string',
      enum: ['WIN_THE_LAST_6_MONTHS', 'WIN_THE_LAST_12_MONTHS', 'WIN_THE_LAST_24_MONTHS', 'OTHER'],
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    when_was_the_last_risk_assessment_conducted: valueSchema,
  },
}
